import type { AmplitudeEventKeys } from '../../amplitude-properties.types';
import { getEventPropsBuilder, toSnakeCase } from '../../utils';

export const trackSearchPageViewed = getEventPropsBuilder(
    (): Partial<AmplitudeEventKeys> => ({
        event: 'Search Page Viewed',
        Module: 'search'
    })
);

export const trackSearchStarted = getEventPropsBuilder(
    (keyword: string): Partial<AmplitudeEventKeys> => ({
        event: 'Search Started',
        Module: 'search',
        'Search Keyword': keyword.toLowerCase()
    })
);

export const trackSearchInitialized = getEventPropsBuilder(
    (keyword: string): Partial<AmplitudeEventKeys> => ({
        event: 'Search Initialized',
        Module: 'search',
        'Search Keyword': toSnakeCase(keyword),
        'Raw Search Keyword': keyword
    })
);

export const trackSearchResultsReturned = getEventPropsBuilder(
    (keyword: string, resultCount: number): Partial<AmplitudeEventKeys> => ({
        event: 'Search Results Returned',
        Module: 'search',
        'Search Keyword': toSnakeCase(keyword),
        'Raw Search Keyword': keyword,
        'Search Results': resultCount
    })
);

export const trackSearchResultSelected = getEventPropsBuilder(
    (keyword: string, resultCount: number, gameId: string): Partial<AmplitudeEventKeys> => ({
        event: 'Search Result Selected',
        Module: 'search',
        'Search Keyword': toSnakeCase(keyword),
        'Raw Search Keyword': keyword,
        'Search Results': resultCount,
        'Game ID': gameId
    })
);
